import Button from "@/components/Button"
import { Modals, useModals } from "@/hooks/useModals"
import { Event } from "@/types/serializers"
import Modal from "@/components/Modal"
import { useForm } from "@inertiajs/react"
import ErrorMessage from "@/components/ErrorMessage"

type Inputs = {
  name: string
  location: string
}

const EditEventModal = ({ event }: { event: Event }) => {
  const { activeModal, closeModal } = useModals()
  const isOpen = activeModal === Modals.EditEvent

  const { data, setData, patch, errors, processing } = useForm<Inputs>({
    name: event.name ?? "",
    location: event.location ?? "",
  })

  const saveEvent = async (e: React.FormEvent) => {
    e.preventDefault()

    patch(`/events/${event.id}`, {
      async: true,
      preserveScroll: true,
      preserveState: true,
      onSuccess: () => closeModal(),
    })
  }

  return (
    <Modal show={isOpen} onClose={closeModal} title="Edit event">
      <form onSubmit={saveEvent} className="mt-4 space-y-4">
        <div>
          <label
            htmlFor="name"
            className="block text-sm leading-6 font-medium text-gray-900"
          >
            Name
          </label>
          <input
            type="text"
            id="name"
            required
            className="focus:ring-chessdrop-600 mt-1 block w-full rounded-lg border-0 py-2 text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
            value={data.name}
            onChange={(e) => setData("name", e.target.value)}
          />
          <ErrorMessage className="mt-1.5" message={errors.name} />
        </div>
        <div>
          <label
            htmlFor="location"
            className="block text-sm leading-6 font-medium text-gray-900"
          >
            Location
          </label>
          <input
            type="text"
            id="location"
            className="focus:ring-chessdrop-600 mt-1 block w-full rounded-lg border-0 py-2 text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset"
            value={data.location}
            onChange={(e) => setData("location", e.target.value)}
          />
          <ErrorMessage className="mt-1.5" message={errors.location} />
        </div>

        <Button loading={processing} type="submit" fullWidth>
          Save event
        </Button>
      </form>
    </Modal>
  )
}

export default EditEventModal
